import { render, staticRenderFns } from "./ContratModal.vue?vue&type=template&id=3cfbc772"
import script from "./ContratModal.vue?vue&type=script&lang=ts"
export * from "./ContratModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports